import { type FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { TrialSuccess } from '../../Common/TrialSuccess'

export const ProfessionalSuccess: FC = () => {
  const navigate = useNavigate()

  return <TrialSuccess buttonLabel='Go to meetings now' onButtonClick={() => navigate('/workspace/upcoming')} />
}
